import { getSupabaseClient } from '../../../../core/supabase/client.js';

export class ServerTimeRemoteDataSource {
  async fetchServerTime(): Promise<Date> {
    const client = getSupabaseClient();
    try {
      const { data, error } = await client.rpc('get_server_time');
      if (!error && data) return new Date(data as string);
      throw error ?? new Error('no data');
    } catch {
      try {
        const { data } = await client.functions.invoke('server-time');
        return new Date((data as { datetime: string }).datetime);
      } catch {
        return new Date();
      }
    }
  }
}
